module.exports = __webpack_public_path__ + "img/education.dd319b42.png";